import { useEffect } from 'react';

export default function HomeSchema() {
  useEffect(() => {
    const schemas = [
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: '米乐体育',
        url: 'https://www.milesports.com',
        logo: 'https://www.milesports.com/logo.png',
        description: '米乐体育是专业的体育综合服务平台，提供足球、篮球、网球等热门赛事直播、数据分析与竞猜服务。',
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '400-888-6666',
          contactType: 'customer service',
          availableLanguage: ['Chinese'],
        },
        sameAs: [
          'https://weibo.com/milesports',
          'https://www.douyin.com/user/milesports',
        ],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: '米乐体育',
        url: 'https://www.milesports.com',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://www.milesports.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
        inLanguage: 'zh-CN',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: '米乐体育官方平台-专业体育赛事直播与竞猜',
        description: '米乐体育是专业的体育综合服务平台，提供足球、篮球、网球等热门赛事直播、数据分析与竞猜服务。',
        url: 'https://www.milesports.com',
        isPartOf: {
          '@type': 'WebSite',
          name: '米乐体育',
          url: 'https://www.milesports.com',
        },
        inLanguage: 'zh-CN',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '米乐体育平台提供哪些体育赛事直播？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '米乐体育平台提供足球、篮球、网球、电竞等全球热门赛事的高清直播服务，覆盖英超、西甲、NBA、温网等顶级联赛。',
            },
          },
          {
            '@type': 'Question',
            name: '如何在米乐体育注册账号？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '您可以通过米乐体育官网或APP进行注册，填写手机号码即可快速完成注册，新用户还可享受专属福利。',
            },
          },
          {
            '@type': 'Question',
            name: '米乐体育的竞猜功能如何使用？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '在米乐体育平台选择您感兴趣的赛事，查看实时赔率数据，选择竞猜选项后提交即可参与。平台提供专业的数据分析辅助决策。',
            },
          },
          {
            '@type': 'Question',
            name: '米乐体育APP在哪里下载？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '您可以在米乐体育官网首页点击"下载APP"按钮，支持iOS和Android系统，也可在各大应用商店搜索"米乐体育"下载。',
            },
          },
        ],
      },
    ];

    const existingScript = document.getElementById('schema-ld-json');
    if (existingScript) {
      existingScript.remove();
    }

    const script = document.createElement('script');
    script.id = 'schema-ld-json';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schemas, null, 2);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById('schema-ld-json');
      if (el) el.remove();
    };
  }, []);

  return null;
}